import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import axios from 'axios'

Vue.config.productionTip = false

Vue.prototype.axios = axios.create({
  // baseURL: 'https://api.acocasa.com/api'
  baseURL: 'https://api2.acocasa.com'
  // baseURL: 'http://localhost:8001/'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
